import TextField, { TextFieldProps } from '@mui/material/TextField'
import React from 'react'

export default function IseTextFiled(props: TextFieldProps) {
  return (
    <TextField
        fullWidth={props.fullWidth === undefined ? true : props.fullWidth }
        size={props.size === undefined ? 'small' : props.size }
        {...props}
        disabled={props.disabled}
        variant={props.variant === undefined ? 'outlined' : props.variant}
    />
  )
}
